import { BigNumber } from 'bignumber.js';

export const formatNumberForResponse = (
  number: string | number | undefined,
  precision?: number | undefined
) => {
  if (number === null || number === undefined) {
    return '';
  }

  if (typeof number === 'number') {
    number = number.toString();
  }
  const shouldUsePrecision = precision !== undefined;

  if (isExponential(number)) {
    const decimalNumber = new BigNumber(number);
    const decimalPrecision = shouldUsePrecision ? precision + 2 : 10;
    number = decimalNumber.toFixed(decimalPrecision, BigNumber.ROUND_DOWN);
  }

  const num = parseFloat(number);

  const minNum = shouldUsePrecision ? 1 * 10 ** -precision : 0.000001;
  if (isNaN(num) || num < minNum) {
    return '0';
  }

  const [intPart, fracPart = ''] = number.split('.');

  if (!fracPart || /^0*$/.test(fracPart)) {
    return (Math.floor(num * 100) / 100).toString();
  }

  const firstNonZeroIndex = fracPart.search(/[1-9]/);
  const cutIndex = shouldUsePrecision
    ? precision
    : Math.min(firstNonZeroIndex + 6, fracPart.length);
  const trimmedFrac = fracPart.slice(0, cutIndex);

  return `${intPart}${trimmedFrac.length > 0 ? '.' : ''}${trimmedFrac}`.replace(
    /\.?0+$/,
    ''
  );
};

function isExponential(num: string): boolean {
  return num.includes('e');
}
